import { AddressModel, DefaultAddress } from "./address.model"

export type UserModel = {
    businessName: string,
    billAddress: AddressModel,
    createdAt: number,
    email: string,
    firstName: string,
    gender: string
    hash: string,
    id: number,
    lastName: string,
    middleName: string,
    phone: PhoneModel,
    postAddress: AddressModel,
    role: string,
    updatedAt: number,
    username: string,
}

export type RoleModel = {
    name: string, // uppercased
    y: number
    prop?: number
}

export type MeDialogInject = {
    userInfo: UserModel,
    title: string,
    from: string
}

export type PhoneModel = {
    iso2: string,
    dialCode: string,
    fullNumber: string
}

export const DefaultPhone: PhoneModel = {
    iso2: 'fr',
    dialCode: '33',
    fullNumber: ''
}

export const DefaultUser: UserModel = {
    id: 0,
    gender: '',
    firstName: '',
    middleName: '',
    lastName: '',
    email: '',
    role: '',
    createdAt: 0,
    updatedAt: 0,
    username: '',
    billAddress: DefaultAddress,
    postAddress: DefaultAddress,
    phone: DefaultPhone,
    hash: '',
    businessName: '',
}

export const DefaultRole: RoleModel = {
    name: "",
    y: 0
}

export const GENDERS = [
    "Abinary",
    "Agender",
    "Agenderfluid",
    "Agenderflux",
    "Genderblank",
    "Genderfree",
    "Polyagender",
    "Ambigender",
    "Androgyne",
    "Androgynous",
    "Aporagender",
    "Autigender",
    "Bakla",
    "Bigender",
    "Binary",
    "Bissu",
    "Butch",
    "Calabai",
    "Calalai",
    "Cis",
    "Cisgender",
    "Cis female",
    "Cis male",
    "Cis man",
    "Cis woman",
    "Demi-boy",
    "Demiflux",
    "Demigender",
    "Demi-girl",
    "Demi-guy",
    "Demi-man",
    "Demi-woman",
    "Dual gender",
    "Eunuch",
    "Fa'afafine",
    "Female",
    "Female to male",
    "Femme",
    "FTM",
    "Gender bender",
    "Gender diverse",
    "Gender gifted",
    "Genderfae",
    "Genderfluid",
    "Genderflux",
    "Genderfuck",
    "Genderless",
    "Gender nonconforming",
    "Genderqueer",
    "Gender questioning",
    "Gender variant",
    "Graygender",
    "Hijra",
    "Intergender",
    "Intersex",
    "Ipsogender",
    "Kathoey",
    "Māhū",
    "M3A3 Bradly",
    "Male",
    "Male to female",
    "Man",
    "Man of trans experience",
    "Maverique",
    "Meta-gender",
    "MTF",
    "Multigender",
    "Muxe",
    "Naruto",
    "Neither",
    "Neurogender",
    "Neutrois",
    "non-binary",
    "Non-binary transgender",
    "Omnigender",
    "Other",
    "Pangender",
    "Person of transgendered experience",
    "Polygender",
    "Prefer not to say",
    "Queer",
    "Sekhet",
    "Third gender",
    "Trans",
    "Trans*",
    "Trans female",
    "Trans male",
    "Trans man",
    "Trans person",
    "Trans woman",
    "Transgender",
    "Transgender female",
    "Transgender male",
    "Transgender man",
    "Transgender person",
    "Transgender woman",
    "Transfeminine",
    "Transmasculine",
    "Transsexual",
    "Transsexual female",
    "Transsexual male",
    "Transsexual man",
    "Transsexual person",
    "Transsexual woman",
    "Travesti",
    "Trigender",
    "Tumtum",
    "Two spirit",
    "Vakasalewalewa",
    "Waria",
    "Winkte",
    "Woman",
    "Woman of trans experience",
    "X-gender",
    "X-jendā",
    "Xenogender"
]